<div class="flex">
    <div class="flex text-normal">
        <app-notifications-dropdown class="ml-4 z-30 flex items-center">
        </app-notifications-dropdown>
        <app-messages-dropdown [onlyOne]="true" class="z-30 ml-4 text-normal flex items-center pt-1" [forMobile] = "forMobile">
        </app-messages-dropdown>
        <div class="right-side md:hidden block mobile-menu text-normal">
            <a *ngIf="giftCount" class="help text-center text-normal font-20-21-iterstate gift-a"  [routerLink]="['/me/task-list']" style="font-size: 25px;position: relative;margin-right: 15px;">
                <span class="circle">{{giftCount}}</span>
                <i class="fa fa-gift"></i>
            </a>
        </div>
    </div>
    <app-profile-dropdown-subdomain [authUser]="authUser" class="z-30 ml-2"></app-profile-dropdown-subdomain>
</div>

